/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

/**
 * Styled Material-UI Tooltip with custom HTML content support.
 * Provides light-themed tooltip with border and custom typography.
 * 
 * Features:
 * - Light background (#f5f5f9)
 * - Dark text color
 * - Max width 220px
 * - Theme-responsive font size
 * - Border styling
 * - Supports HTML content
 * 
 * Styling:
 * - Background: Light gray
 * - Text: Near-black with transparency
 * - Border: Light gray (#dadde9)
 * - Font size: Responsive via theme
 * 
 * @returns Styled tooltip component for HTML content
 */
const HtmlTooltip = ({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: `${className} HtmlTooltip-html-tooltip` }} />
);

export default HtmlTooltip;